import React from 'react';
import './waivers.css';
import { connect } from 'react-redux';
import {
  updateWaiverFilter,
  updateSelectedWaiver
} from '../../../actions/adminActions/waiversActions';
import { waivers } from '../../../apis/backend'; //make sure to include this for each page
import EditWaiverModal from './waiverModals/editWaiverModal.jsx';
import AddWaiverModal from './waiverModals/addWaiverModal.jsx';

class Waivers extends React.Component {
  async waiverDeleteRequest(id) {
    await waivers
      .delete(`/${id}`, {
        headers: { authorization: this.props.employeeToken }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  renderwaivers() {
    //renders the waivers table
    return (
      <>
        {this.props.waivers
          .filter((waiver) => {
            const filterString = `${waiver.name}`;
            return filterString.toLowerCase().indexOf(this.props.waiverFilter.toLowerCase()) > -1;
          })
          .map((waiver) => (
            <tr key={this.props.waivers.indexOf(waiver)}>
              <td className="text-center" style={{ width: '24%' }}>
                {`${waiver.name}`}
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                <div
                  data-target="#exampleModal"
                  className="btn btn-sm btn-dark"
                  data-toggle="modal"
                  onClick={() => {
                    this.props.updateSelectedWaiver(waiver.id);
                  }}
                >
                  Edit
                </div>
              </td>
              <td className="text-center permission-super-admin " style={{ width: '9%' }}>
                {
                  // Liability waiver (id=1) cannot be removed
                }
                {waiver.id != 1 && (
                  <div
                    className="btn btn-sm btn-dark disabled"
                    data-target="#deleteModal"
                    data-toggle="modal"
                    onClick={() => {
                      this.props.updateSelectedWaiver(waiver.id);
                    }}
                  >
                    Remove
                  </div>
                )}
              </td>
            </tr>
          ))}
      </>
    );
  }

  getWaiverName() {
    const waiver = this.props.waivers.find((obj) => obj.id === this.props.selectedWaiver);

    return waiver ? waiver.name : '';
  }

  render() {
    return (
      <div className="waivers-page">
        <div className="container">
          <div
            className="form-inline md-form form-sm mt-4"
            style={{ fontSize: '36px', color: '#fff' }}
          >
            <div style={{ margin: 'auto', height: '48px', width: '100%' }}>Waivers</div>
          </div>
          <div className="form-inline md-form form-sm mt-3">
            <input
              value={this.props.waiverFilter}
              className="form-control form-control-lg w-45"
              type="text"
              placeholder="Search"
              aria-label="Search"
              onChange={(e) => {
                this.props.updateWaiverFilter(e.target.value);
              }}
            />
            <div
              data-target="#addModal"
              className="btn btn-lg btn-dark permission-super-admin"
              data-toggle="modal"
              style={{ marginLeft: '10px' }}
            >
              Add Waiver
            </div>
          </div>
          <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table className="table table-striped  table-bordered table-hover bg-white mt-1 mr-3">
              <thead className="bg-dark thead-dark">
                <tr>
                  <th className="text-center" style={{ width: '24%' }}>
                    Name
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Edit
                  </th>
                  <th className="text-center permission-super-admin " style={{ width: '9%' }}>
                    Remove
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderwaivers()}</tbody>
            </table>
          </div>
        </div>

        <AddWaiverModal />
        <EditWaiverModal />

        <div className="modal fade" id="deleteModal" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content" style={{ width: '80%', margin: '0 auto' }}>
              <div className="modal-header">
                <h5 className="modal-title">Are you Sure?</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    this.props.updateSelectedWaiver(0);
                  }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body" style={{ textAlign: 'center', fontSize: '18px' }}>
                <strong>&apos;{this.getWaiverName()}&apos;</strong> will be deleted forever!!
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.waiverDeleteRequest(this.props.selectedWaiver);
                    this.props.updateSelectedWaiver(0);
                  }}
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.updateSelectedWaiver(0);
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  waivers: state.admin.admin.waivers,
  waiverFilter: state.admin.waivers.waiverFilter,
  selectedWaiver: state.admin.waivers.selectedWaiver,
  employeeToken: state.auth.employeeToken
});

export default connect(mapStateToProps, {
  updateWaiverFilter,
  updateSelectedWaiver
})(Waivers);
